/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import adduser from '../../../images/AddUser.png';
import { networkDataInterface } from '../../viewNetwork/dedicatedNetwork/allNetworkBody';
// import Urls from "../../utils/Urls";
import subFunction from '../helpers';
import BaseUrls from '../../../utils/baseUrls';
import { prefixPath } from '../../../utils/helpers';

interface customData extends networkDataInterface {
    cardnumber: number,
    total: number,
    card_type: 'allNetwork' | 'workspace' | 'allStakingNetwork'
}
const NetworkCard = ({
  id,
  name,
  type,
  activeNodes,
  inactiveNodes,
  frontendBaseSuburl,
  customDashboardUrl,
  cardnumber,
  total,
  inProgressNodes,
  protocolName,
  createdAt,
  card_type,
  nodeType,
  protocolType,
  status,
}: customData) => {
  const setImage = (val: string) => {
    if (val.includes(' ')) {
      // eslint-disable-next-line prefer-destructuring, no-param-reassign
      val = val.replace(/\s/g, '');
    }
    switch (val.toLowerCase()) {
      case 'corda': return 'images/protocols/logos/corda_logo.svg';
      case 'r3': return 'images/protocols/logos/corda_logo.svg';
      case 'ethereum': return 'images/protocols/logos/ethereum_logo.svg';
      case 'credit': return 'images/protocols/logos/credits.png';
      case 'fabric': return 'images/protocols/logos/Hyperledger-Fabric_logo.svg';
      case 'sawtooth': return 'images/protocols/logos/sawtooth_logo.svg';
      case 'fluree': return 'images/protocols/logos/fluree_logo.svg';
      case 'phaeton': return 'images/protocols/logos/phaeton_logo.svg';
      case 'polygon': return 'images/protocols/logos/Polygonpos_logo.svg';
      case 'binance': return 'images/protocols/logos/binance_logo.svg';
      case 'tron': return 'images/protocols/logos/tron_logo.svg';
      case 'avalanche': return 'images/protocols/logos/avalanche_logo.svg';
      case 'axia': return 'images/protocols/logos/axia_logo.svg';
      case 'fantom': return 'images/protocols/logos/Fantom_logo.svg';
      case 'dcomm': return 'images/protocols/logos/dcommdark_logo.svg';
      case 'polkadot': return 'images/protocols/logos/Polkadot_logo.svg';
      case 'okc': return 'images/protocols/logos/okc_logo.svg';
      case 'aptos': return 'images/protocols/logos/Aptos_logo.svg';
      case 'coreum': return 'images/protocols/logos/Coreum_logo.svg';
      case 'shardeum': return 'images/protocols/logos/Shardeum_logo.svg';
      case 'ewx': return 'images/protocols/logos/Energy_Web_Logo.svg';
      case 'polygon-edge': return 'images/protocols/logos/Polygon-Edge_logo.svg';
      case 'hyperledgerbesu': return 'images/protocols/logos/besu-icon.svg';
      case 'polygoncdkchain': return 'images/protocols/logos/Polygon_cdk.svg';
      case 'parachains': return 'images/protocols/logos/parachains_logo.svg';
      case 'cordaenterprise': return 'images/protocols/logos/corda_logo.svg';
      case 'acala': return 'images/protocols/logos/acala_logo.svg';
      case 'algorand': return 'images/protocols/logos/algorand_logo.svg';
      case 'arbitrum': return 'images/protocols/logos/arbitrum_logo.svg';
      case 'aurora': return 'images/protocols/logos/aurora_logo.svg';
      case 'base': return 'images/protocols/logos/base_logo.svg';
      case 'bitcoin': return 'images/protocols/logos/bitcoin_logo.svg';
      case 'harmony': return 'images/protocols/logos/harmony_logo.svg';
      case 'crossfi': return 'images/protocols/logos/crossfi_logo.png';
      case 'klaytn': return 'images/protocols/logos/klaytn_logo.svg';
      case 'kusama': return 'images/protocols/logos/kusama_logo.svg';
      case 'moonbeam': return 'images/protocols/logos/Moonbeam_logo.svg';
      case 'near': return 'images/protocols/logos/near_logo.svg';
      case 'optimism': return 'images/protocols/logos/optimism_logo.svg';
      case 'tezos': return 'images/protocols/logos/tezos_logo.svg';
      case 'arbitrumnova': return 'images/protocols/logos/arbitrum_nova_logo.svg';
      case 'cardano': return 'images/protocols/logos/cardano_logo.svg';
      case 'celo': return 'images/protocols/logos/celo_logo.svg';
      case 'cosmos': return 'images/protocols/logos/cosmos_logo.svg';
      case 'cronos': return 'images/protocols/logos/cronos_logo.svg';
      case 'flow': return 'images/protocols/logos/flow_logo.svg';
      case 'fuse': return 'images/protocols/logos/fuse_logo.svg';
      case 'gnosischain': return 'images/protocols/logos/gnosischain_logo.svg';
      case 'hedera': return 'images/protocols/logos/hedera_logo.svg';
      case 'lisk': return 'images/protocols/logos/lisk_logo.svg';
      case 'nervos': return 'images/protocols/logos/nervos_logo.svg';
      case 'persistence': return 'images/protocols/logos/persistence_logo.svg';
      case 'solana': return 'images/protocols/logos/solana_logo.svg';
      case 'stacks': return 'images/protocols/logos/stacks_logo.svg';
      case 'ton': return 'images/protocols/logos/ton_logo.svg';
      case 'telos': return 'images/protocols/logos/telos_logo.svg';
      case 'xdc': return 'images/protocols/logos/xdc_logo.svg';
      case 'zkevm': return 'images/protocols/logos/zkevm_logo.svg';
      case 'starknet': return 'images/protocols/logos/starknet_logo.png';
      case 'avalanche-subnets': return 'images/protocols/logos/avalanche_logo.svg';
      case 'provenanceblockchain': return 'images/protocols/logos/provenance_blockchain_logo.svg';
      case 'bahamut': return 'images/protocols/logos/fastex_logo.svg';
      case 'zksyncera': return 'images/protocols/logos/zksyncera_logo.svg';
      case 'opstack': return 'images/protocols/logos/opstack_logo.svg';
      case 'arbitrumorbit': return 'images/protocols/logos/arbitrum_orbit_logo.svg';
      case 'shido': return 'images/protocols/logos/shido_logo.svg';
      case 'subsquid': return './images/protocols/logos/subsquid-logo-dark.svg';
      case 'beaml1': return './images/protocols/logos/beam_logo.svg';
      case 'l1': return './images/protocols/logos/beam_logo.svg';
      case 'beam': return './images/protocols/logos/beam_logo.svg';
      default: return '';
    }
  };
  const theme = BaseUrls.getkey();
  const baseUrl = window.location.origin;
  const activeNodeImg = baseUrl + prefixPath(`/img/${theme}/active-nodes.png`);
  const inActiveNodeImg = baseUrl + prefixPath(`/img/${theme}/inactive-nodes.png`);

  const getRedirectionUrl = (baseUrl: string, protocolType: string, networkId: string, nodeType? : string | null, customDashboardUrl?: string) => {
    if (customDashboardUrl) {
      return customDashboardUrl;
    }

    if (protocolType === 'public') {
      const finalNodeType = nodeType ?? '';

      if (['full', 'fullnode', 'rpc'].includes(finalNodeType.toLowerCase())) {
        return `${baseUrl}/nodes/full/${id}`;
      }
      if (['validator', 'staking', 'stake'].includes(finalNodeType.toLowerCase())) {
        return `${baseUrl}/nodes/validator/${id}`;
      }
    }

    return `${baseUrl}/network/${id}`;
  };

  const getBadgeLabel = (protocolType: string, nodeType? :string | null) => {
    if (protocolType === 'public') {
      const finalNodeType = nodeType ?? '';

      if (['full', 'fullnode', 'rpc'].includes(finalNodeType.toLowerCase())) {
        return 'Full Node';
      }
      if (['validator', 'staking', 'stake'].includes(finalNodeType.toLowerCase())) {
        return 'Validator Node';
      }
    } else if (protocolType === 'permissioned') {
      return 'Network';
    }

    return 'AppChains';
  };

  return (
        <div className="col-lg-4 col-xl-3 col-md-6 col-sm-12 mt-5 ">
            <div className="card workSpaceCard">
                <div className="card-body">
                    <div className="d-flex justify-content-between">
                        <div className="col-10">
                            <img
                                src={`${card_type === 'allNetwork' ? './' : '../'}${setImage(protocolName)}`}
                                height="30px"
                                alt=""
                            />
                        </div>
                        <div className="d-flex justify-content-end">
                            <div className="square2 rounded-2 px-2 cursor" onClick={() => { subFunction('action', cardnumber, total); }}>
                                <i className="fas fa-ellipsis-v mx-2" />
                                <ul
                                    className="dropdown-menu collapse bg-card "
                                    aria-labelledby=""
                                    id={`action${cardnumber}`}
                                >
                                    <li>
                                        <a href={getRedirectionUrl(frontendBaseSuburl, protocolType, id, nodeType, customDashboardUrl)} className="dropdown-item" type="">
                                            {' '}
                                            <img className="mx-2" src={adduser} alt="" />
                                            View
{' '}
{protocolType === 'public' ? 'Node' : 'Network'}

                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div className="row mt-4 mb-4">
                        <div className="col-xl-7 col-7 col-md-4">
                            <a href={getRedirectionUrl(frontendBaseSuburl, protocolType, id, nodeType, customDashboardUrl)} className="workspaceCardHeading" style={{ textDecoration: 'none' }}>
                                {' '}
                                <strong>{name}</strong>
                                {' '}
                            </a>
                        </div>
                        <span className="badge text-center col-4">{getBadgeLabel(protocolType, nodeType)}</span>
                    </div>
                    <div className="mt-2 a-tag">
                        <div className="d-flex align-items-center">
                            <div className="col-2">
                               <img className="px-1" src={activeNodeImg} alt="" />
                            </div>
                            <div className="col-8 my-auto ms-1">Active Nodes</div>
                            <div className="col-3 mx-auto" style={{ paddingLeft: '10px' }}>
                                <strong>{activeNodes}</strong>
                            </div>
                        </div>
                    </div>
                    <div className="mt-3 mb-1 a-tag">
                        <div className="d-flex align-items-center">
                            <div className="col-2">
                                <img className="px-1" src={inActiveNodeImg} alt="" />
                            </div>
                            <div className="col-8 my-auto ms-1">Nodes In-Provisioning</div>
                            <div className="col-3 mx-auto" style={{ paddingLeft: '10px' }}>
                                <strong>{inProgressNodes}</strong>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="card-footer a-tag">
                    <div className="d-flex">
                        <div className="col-11">
                            <p className="create m-auto mt-1">
                                Created on
                                {' '}
                                {(new Date(createdAt || '')).toDateString()}
                            </p>
                        </div>
                        <div className="col-2">
                            {/* <img
                                    data-bs-toggle="tooltip"
                                    title="Process Cancel"
                                    src={statuscancel}
                                    alt=""
                                /> */}
                        </div>
                    </div>
                </div>
            </div>
        </div>

  );
};

export default NetworkCard;
